import { SUPPLIER_SELECT as LABELS } from './labels.js';
import { DIALOG_TABLE_MAX_HEIGHT } from '../../../../lib/const';
import { generateDictURLWithLang, getApiPath } from '../../../../lib/utils';
// import { getUserInfo } from '../../../../lib/auth';

const baseUrl = getApiPath();
// const userInfo = getUserInfo();
// const elsAccount = userInfo.elsAccount;

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    highlightCurrentRow: true,
    selection: false,
    searchShow: false,
    searchBtn: true,
    addBtn: false,
    columnBtn: false,
    refreshBtn: false,
    menu: false,
    index: true,
    indexLabel: LABELS.serialNumber,
    border: true,
    labelPosition: 'top',
    searchSpan: 12,
    searchMenuSpan: 12,
    maxHeight: DIALOG_TABLE_MAX_HEIGHT,
    emptyText: LABELS.noData,
    column: [
      {
        slot: true,
        label: '',
        width: 70,
        prop: 'checked'
      },
      {
        label: LABELS.supplierAccount,
        prop: 'toElsAccount',
        searchSpan: 8,
        searchLabelWidth: 140,
        search: true
      },
      {
        label: LABELS.supplierName,
        prop: 'supplierName',
        overHidden: true,
        searchSpan: 8,
        searchLabelWidth: 140,
        search: true
      },
      {
        label: LABELS.state,
        prop: 'firstType',
        type: 'select',
        dicUrl: generateDictURLWithLang(
          `${baseUrl}/ElsSearchDictionaryService/no-auth/dict/supplierType`,
          true
        )
      },
      /*
      {
        label: '物料分类',
        prop: 'accessCategory',
        type: 'select',
        searchSpan: 8,
        searchLabelWidth: 140,
        search: true,
        searchslot: true,
        // dicUrl: `${baseUrl}/MaterialCateService/getMaterialCateTree?elsAccount=${elsAccount}`,
        hide: true
      }
      */
      {
        label: LABELS.purchasingOrganization,
        prop: 'accessCategory',
        searchSpan: 8,
        search: true
      }
    ]
  }
};
